import { ComponentProps, FileUrlProvider } from "api-sdk-react"
import { ReaderConfig, SelectComponent, SelectComponentType, TextInputConstraints, useMessages } from "reader-common"
import React from "react"
import { ChatActionOutline, ChatMessageData } from "api-sdk"
import { ChatState } from "../inputContainer"

export interface ChatNodeInputProps extends ComponentProps {
    chatState: ChatState,
    setChatState: (state: ChatState) => void,
    autoFocus: boolean,
    config: ReaderConfig,
    fileUrlProvider: FileUrlProvider,
    action?: ChatActionOutline,
    onSendChatMessage: (message: ChatMessageData) => void,
}

export function ChatNodeInput(props: ChatNodeInputProps) {
    const chatState = props.chatState
    const M = useMessages()

    const actionButtons = props.action && !chatState.isActionDismissed ? (
        <SelectComponent
            options={ [
                { id: props.action.id, idx: 0, label: props.action?.label },
                { id: -1, idx: 1, label: props.action.falseLabel || M.input.boolean.false }
            ] }
            onChange={ id => {
                if (id === -1) {
                    props.setChatState({
                        ...props.chatState,
                        isActionDismissed: true,
                        pendingChatMessage: props.action?.falseLabel || M.input.boolean.false
                    })
                    props.onSendChatMessage({message: props.action.falseLabel || M.input.boolean.false})
                } else {
                    props.setChatState({ ...chatState, pendingChatMessage: props.action.label })
                    props.onSendChatMessage({actionId: props.action.id})
                }
            } }
            optionClassName="chat-surface"
            fileUrlProvider={ props.fileUrlProvider }
            selectType={ SelectComponentType.SINGLE_CHOICE }
            isOptional={ false }
        />
    ) : null

    return (
        <div>
            { actionButtons ?? (
                <div className={ "text-input chat-surface input-target text-field" }>
                    <input
                        autoFocus={ !!props.autoFocus }
                        value={ props.chatState.chatMessageDraft }
                        placeholder={ props.config.messages.chatInputLabel }
                        title={ props.config.messages.chatInputLabel }
                        onChange={ (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => props.setChatState(
                            { ...props.chatState, pendingChatMessage: e.target.value || "", chatMessageDraft: e.target.value || ""}
                        ) }
                    />
                    <TextInputConstraints
                        field={ {id: -1, maxLength: 200, minLength: 0, required: true, valueType: "TEXT"} }
                        inputText={ props.chatState.chatMessageDraft }
                        config={ props.config }
                    />
                </div>
            ) }
        </div>
    )

}